import { useTranslation } from "react-i18next";

export default function ContactCards() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: "ri-phone-line",
      title: t("support.contact1_title"),
      main: t("support.contact1_num"),
      sub: t("support.contact1_hours"),
      color: "bg-red-50",
      iconColor: "text-red-600",
    },
    {
      icon: "ri-mail-line",
      title: t("support.contact2_title"),
      main: t("support.contact2_addr"),
      sub: t("support.contact2_time"),
      color: "bg-green-50",
      iconColor: "text-green-600",
    },
    {
      icon: "ri-customer-service-2-line",
      title: t("support.contact3_title"),
      main: t("support.contact3_btn"),
      sub: t("support.contact3_status"),
      color: "bg-blue-50",
      iconColor: "text-blue-600",
      isBtn: true,
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {cards.map((card, i) => (
          <div key={i} className="bg-white rounded-2xl p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform cursor-default">
            <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${card.color}`}>
              <i className={`${card.icon} text-lg ${card.iconColor}`} />
            </div>
            <div>
              <div className="text-xs text-gray-400 mb-1">{card.title}</div>
              {card.isBtn ? (
                <button className="text-sm font-semibold text-blue-600 cursor-pointer hover:text-blue-800 transition-colors whitespace-nowrap">
                  {card.main} <i className="ri-arrow-right-line" />
                </button>
              ) : (
                <div className="text-sm font-semibold text-gray-900">{card.main}</div>
              )}
              <div className="text-xs text-gray-400 mt-0.5">{card.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
